import { z } from "zod";
export const deleteAccountRequestSchema = z.object({ confirmation: z.literal("DELETE") }).strict();
export const deleteAccountResponseSchema = z.object({ deleted: z.literal(true) }).strict();
export const deleteAccountErrorDetailsSchema = z
    .object({ deletionState: z.enum(["auth-deleted", "manual-review"]) })
    .strict();
//# sourceMappingURL=account-deletion.js.map